var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"password-strength-meter",class:{ mounted: _vm.isMounted }},[_c('div',{staticClass:"password-strength-meter--fill",attrs:{"data-score":_vm.score}}),(_vm.label)?_c('div',{staticClass:"password-strength-label"},[_c('span',[_vm._v(_vm._s(_vm.label))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }